<p-toast [baseZIndex]="1000" position="top-left"></p-toast>
<div class="container-fluid">
  <form [formGroup]="entidadeForm" autocomplete="off">
    <div class="card-panel mt-5">
      <div class="row">
        <div class="col-md-6">
          <lib-page-header page-title="FORNECEDOR/CREDOR"
            page-subtitle="EXERCÍCIO:  {{login.exercicio.ano}} - {{login['ppa']['descricao']}}"
            image-title="assets/img/global/fornecedor.png">
          </lib-page-header>
        </div>
        <div class="col-md-6">
          <button (click)="sair()" class="btn btn-sm btn-outline-secondary float-right ml-5">
            <img src="assets/img/global/cross.png" alt="cvs" title="Sair" height="20" width="20">
          </button>
          <a [routerLink]="['/favorecidos']" class="btn btn-sm btn-outline-secondary float-right">
            <img src="assets/img/global/table_sort_filter.png" alt="pesquisa" title="Pesquisar" height="22" width="22">
          </a>
          <button (click)="submitForm()" type="submit" class="btn btn-outline-info float-right mr-4"
            style="font-size: 13px">Salvar favorecido</button>
        </div>
      </div>
      <hr class="mt-0 mb-4" />
      <ul class="nav nav-tabs" role="tablist">
        <li class="nav-item">
          <a class="nav-link active" (click)="selecionatTab(0)" href="#tab1" role="tab" data-toggle="tab">Dados do
            favorecido</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" (click)="selecionatTab(1)" href="#tab2" role="tab" data-toggle="tab">Contas bancárias</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" (click)="selecionatTab(2)" href="#tab3" role="tab" data-toggle="tab">CNAE</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" (click)="selecionatTab(3)" href="#tab7" role="tab" data-toggle="tab">Gestores</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" (click)="selecionatTab(4)" href="#tab4" role="tab" data-toggle="tab">Penalidades</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" (click)="selecionatTab(5)" href="#tab5" role="tab" data-toggle="tab">Observações</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" (click)="selecionatTab(6)" href="#tab6" role="tab" data-toggle="tab">Catálogo de
            Produtos</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" (click)="selecionatTab(7)" href="#tab8" role="tab" data-toggle="tab">Terceiro Setor</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" (click)="selecionatTab(8)" href="#tab9" role="tab" data-toggle="tab">Capacidade
            técnica</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="#tab10" role="tab" data-toggle="tab">Histórico de alterações</a>
        </li>
      </ul>
      <!-- Tab panes -->
      <div class="tab-content">
        <div role="tabpanel" class="tab-pane active" id="tab1">
          <br />
          <div class="form-row">
            <div class="col-9">
              <div class="d-flex flex-column">
                <label class=" mr-2" style="color: #009688; font-size: 1.2rem;"><strong>Código:</strong>
                  #{{entidade.id}}</label>
                <span>
                  <strong>Data Cadastro:</strong> {{entidade.data_cadastro | date:'dd/MM/yyyy':'GMT'}}</span>
              </div>
            </div>
            <!--Opções selecionaveis do fornecedor-->
            <div class="col-sm-3 d-flex align-items-center justify-content-end">
              <div class="btn-group">
                <button class="btn btn-outline-info btn-sm dropdown-toggle" type="button" data-toggle="dropdown"
                  aria-expanded="false">
                  <em class="far fa-check-square"></em>
                  Opções Fornecedor / Credor
                </button>
                <div (click)="$event.stopPropagation()" class="dropdown-menu dropdown-menu-right" style="width: 230px;">
                  <ul class="list-group list-group-flush">
                    <li class="list-group-item">
                      <div class="checkbox checbox-switch switch-danger">
                        <label>
                          <input type="checkbox" formControlName="autorizado" /><span></span>Autorizado
                        </label>
                      </div>
                    </li>
                    <li class="list-group-item">
                      <div class="checkbox checbox-switch switch-danger">
                        <label>
                          <input type="checkbox" formControlName="inativo" /><span></span>Inativo
                        </label>
                      </div>
                    </li>
                    <li class="list-group-item">
                      <div class="checkbox checbox-switch switch-primary">
                        <label>
                          <input type="checkbox" formControlName="servidor" /><span></span>Servidor municipal
                        </label>
                      </div>
                    </li>
                    <li class="list-group-item">
                      <div class="checkbox checbox-switch switch-primary">
                        <label>
                          <input type="checkbox" formControlName="autarquia" /><span></span>Autarquia municipal
                        </label>
                      </div>
                    </li>
                    <li class="list-group-item">
                      <div class="checkbox checbox-switch switch-primary">
                        <label>
                          <input type="checkbox" formControlName="simples_nacional" /><span></span>Simples nacional
                        </label>
                      </div>
                    </li>
                    <li class="list-group-item">
                      <div class="checkbox checbox-switch switch-primary">
                        <label>
                          <input type="checkbox" formControlName="irrf" /><span></span>IRRF
                        </label>
                      </div>
                    </li>
                    <li class="list-group-item">
                      <div class="checkbox checbox-switch switch-primary">
                        <label>
                          <input type="checkbox" formControlName="inss" /><span></span>INSS
                        </label>
                      </div>
                    </li>
                    <li class="list-group-item">
                      <div class="checkbox checbox-switch switch-primary">
                        <label>
                          <input type="checkbox" formControlName="gasto_fixo" /><span></span>Gasto Fixo
                        </label>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <!--Opções selecionaveis do fornecedor-->
          </div>
          <hr class="mt-2 mb-2" />
          <div class="form-row mb-4">
            <div class="col-sm-8">
              <p-panel [toggleable]="true" collapseIcon="fa fa-eye" expandIcon="fa fa-eye-slash">
                <ng-template pTemplate="header">
                  <div>
                    <em class="fa fa-user-tie mr-1"></em>
                    Dados do Fornecedor / Credor
                  </div>
                </ng-template>
                <div class="form-row">
                  <div class="form-group col-md-4">
                    <label for="tipo_favorecido">Tipo<span class="text-danger">*</span></label>
                    <select name="tipo_favorecido" formControlName="tipo_favorecido" class="custom-select">
                      <option [value]="item" *ngFor="let item of listaTiposFavorecido">
                        {{globalService.tituloTipoFavorecido(item)}}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-8">
                    <label for="selectTipo">Espécie<span class="text-danger">*</span></label>
                    <select #tipo_ [compareWith]="compareFn" name="selectTipo" formControlName="tipo"
                      class="custom-select">
                      <option [ngValue]="item" *ngFor="let item of listaTipos">{{item.nome}}</option>
                    </select>
                  </div>
                  <div *ngIf="entidadeForm.get('tipo').value" class="form-group col-md-4">
                    <label *ngIf="entidadeForm.get('tipo').value.tce === '1'" for="nome">CNPJ<span
                        class="text-danger">*</span></label>
                    <p-inputMask #cpf_ (onBlur)="buscarReceitaFederal()"
                      *ngIf="entidadeForm.get('tipo').value.tce === '1'" id="cnpj" formControlName="cpf_cnpj"
                      [disabled]="(entidadeForm.get('id').value != null ? 'disabled' : '')" mask="99.999.999/9999-99"
                      unmask="true" slotChar=" " styleClass="form-control">
                    </p-inputMask>
                    <label *ngIf="entidadeForm.get('tipo').value.tce === '2'" for="cnpj">CPF<span
                        class="text-danger">*</span></label>
                    <p-inputMask #cpf_ (onBlur)="validarCPFCNPJ()" *ngIf="entidadeForm.get('tipo').value.tce === '2'"
                      id="cnpj" formControlName="cpf_cnpj" mask="999.999.999-99" unmask="true" slotChar=" "
                      styleClass="form-control">
                    </p-inputMask>
                    <label
                      *ngIf="entidadeForm.get('tipo').value.tce !== '1' && entidadeForm.get('tipo').value.tce !== '2'"
                      for="cnpj">
                      Inscrição<span class="text-danger">*</span>
                    </label>
                    <input #cpf_ (onBlur)="validarCPFCNPJ()" formControlName="cpf_cnpj"
                      *ngIf="entidadeForm.get('tipo').value.tce !== '1' && entidadeForm.get('tipo').value.tce !== '2'"
                      id="cnpj" class="form-control" />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group col-md-3">
                    <label for="selectEnq">Enquadramento<span class="text-danger">*</span></label>
                    <select name="selectEnq" formControlName="enquadramento" class="custom-select">
                      <option [value]="item.id" *ngFor="let item of listaEnquadramento">
                        {{item.nome}}
                      </option>
                    </select>
                  </div>
                  <div class="form-group col-md-3">
                    <label for="inscricao_estadual">Inscrição Estadual</label>
                    <input formControlName="inscricao_estadual" type="text" class="form-control font-weight-bold"
                      id="inscricao_estadual">
                  </div>
                  <div class="form-group col-md-3">
                    <label for="inscricao_municipal">Inscrição Municipal</label>
                    <input formControlName="inscricao_municipal" type="text" class="form-control font-weight-bold"
                      id="inscricao_municipal">
                  </div>
                  <div class="form-group col-md-3">
                    <label for="inscricao_inss">Inscrição INSS</label>
                    <input formControlName="inscricao_inss" type="text" class="form-control font-weight-bold"
                      id="inscricao_inss">
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12">
                    <label for="razao_social">Nome/Razão social<span class="text-danger">*</span></label>
                    <input formControlName="nome" type="text" class="form-control font-weight-bold" id="razao_social">
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12">
                    <label for="fantasia">Nome Fantasia<span class="text-danger">*</span></label>
                    <input formControlName="nome_fantasia" type="text" class="form-control" id="fantasia">
                  </div>
                </div>
                <div class="row">
                  <div class="form-group col-md-12">
                    <label for="gps">Código GPS</label>
                    <p-autoComplete id="gps" formControlName="gps" [forceSelection]="true" [autoHighlight]="true"
                      [field]="codigoGpsAutoComplete.conversor" [suggestions]="codigoGpsAutoComplete.lista"
                      (completeMethod)="codigoGpsAutoComplete.filtrar($event)" inputStyleClass="form-control"
                      minLength="2" [style]="{ width: '100%' }">
                      <ng-template let-gps pTemplate="item">
                        {{gps.descricao}}
                      </ng-template>
                    </p-autoComplete>
                  </div>
                </div>
              </p-panel>
            </div>
            <div class="col-sm-4">
              <p-panel [toggleable]="true" collapseIcon="fa fa-eye" expandIcon="fa fa-eye-slash">
                <ng-template pTemplate="header">
                  <div>
                    <em class="fa fa-address-card mr-1"></em>
                    Dados Complementares
                  </div>
                </ng-template>
                <ng-template pTemplate="icons">
                  <button pRipple pButton class="p-panel-header-icon p-link" (click)="menu_.toggle($event)"
                    icon="fa fa-plus"></button>
                  <p-menu #menu_ appendTo="body" [popup]="true" [model]="optionsContatos"></p-menu>
                </ng-template>
                <div class="row">
                  <div class="col-md-12" style="height: 480px; overflow-y: auto; overflow-x: hidden;">
                    <lib-favorecido-contato [login]="login" [(lista)]="listaContatos" [favorecido]="entidade">
                    </lib-favorecido-contato>
                  </div>
                </div>
              </p-panel>
            </div>
          </div>
          <div class="form-row  mb-4">
            <div class="col-md-12 col-lg-12 col-xl-12">
              <p-panel [toggleable]="true" collapseIcon="fa fa-eye" expandIcon="fa fa-eye-slash">
                <ng-template pTemplate="header">
                  <div>
                    <em class="fa fa-map-marked-alt mr-1"></em>
                    Endereço do Fornecedor / Credor
                  </div>
                </ng-template>
                <div class="row">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="form-group col-md-4">
                        <label for="cep">CEP<span class="text-danger">*</span></label>
                        <p-inputMask unmask="true" (onBlur)="buscarCEP()" id="cep" formControlName="cep"
                          mask="99.999-999" slotChar=" " styleClass="form-control">
                        </p-inputMask>
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-md-10">
                        <label for="endereco">Endereço<span class="text-danger">*</span></label>
                        <input formControlName="endereco" type="text" class="form-control" id="endereco">
                      </div>
                      <div class="form-group col-md-2">
                        <label for="num_end">Número<span class="text-danger">*</span></label>
                        <input #numero_ formControlName="num_endereco" type="text" class="form-control" id="num_end">
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-sm-12 form-group">
                        <label for="complemento">Complemento</label>
                        <input formControlName="complemento" type="text" class="form-control" id="complemento">
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-md-5">
                        <label for="bairro">Bairro<span class="text-danger">*</span></label>
                        <input formControlName="bairro" type="text" class="form-control" id="bairro">
                      </div>
                      <div class="form-group col-md-4">
                        <label for="bairro">Cidade<span class="text-danger">*</span></label>
                        <input formControlName="municipio" type="text" class="form-control">
                      </div>
                      <div class="form-group col-md-3">
                        <label for="uf">UF<span class="text-danger">*</span></label>
                        <p-autoComplete [(ngModel)]="uf" [ngModelOptions]="{standalone: true}" [autoHighlight]="true"
                          [suggestions]="listaEstados" (completeMethod)="filterEstado($event)" name="uf" field="nome"
                          [dropdown]="true" inputStyleClass="form-control" [style]="{ width: '100%' }">
                          <ng-template let-estado pTemplate="item">
                            <div class="d-flex">
                              <img [src]="'assets/img/estados/' + estado.uf + '.jpg'" height="20" class="mr-2" alt="" />
                              <div>{{estado.nome}}</div>
                            </div>
                          </ng-template>u
                        </p-autoComplete>
                      </div>
                    </div>
                  </div>
                </div>
              </p-panel>
            </div>
          </div>
        </div>
        <div role="tabpanel" class="tab-pane fade" id="tab2">
          <br />
          <lib-favorecido-banco [usarAtalho]="tabSelecionado(1)" [lista]="listaContaBancos" [login]="login">
          </lib-favorecido-banco>
        </div>
        <div role="tabpanel" class="tab-pane fade" id="tab3">
          <br />
          <lib-favorecido-cnae [usarAtalho]="tabSelecionado(2)" [lista]="listaCnaes" [login]="login">
          </lib-favorecido-cnae>
        </div>
        <div role="tabpanel" class="tab-pane fade" id="tab7">
          <br />
          <lib-favorecido-socio [usarAtalho]="tabSelecionado(3)" [lista]="listaSocios" [login]="login">
          </lib-favorecido-socio>
        </div>
        <div role="tabpanel" class="tab-pane fade" id="tab4">
          <br />
          <lib-favorecido-penalidade [usarAtalho]="tabSelecionado(4)" [lista]="listaPenalidades" [login]="login">
          </lib-favorecido-penalidade>
        </div>
        <div role="tabpanel" class="tab-pane fade" id="tab5">
          <br />
          <lib-favorecido-observacao [usarAtalho]="tabSelecionado(5)" [lista]="listaObservacoes" [login]="login">
          </lib-favorecido-observacao>
        </div>
        <div role="tabpanel" class="tab-pane fade" id="tab6">
          <br />
          <lib-favorecido-produto [usarAtalho]="tabSelecionado(6)" [lista]="listaProdutos" [login]="login">
          </lib-favorecido-produto>
        </div>
        <div role="tabpanel" class="tab-pane fade" id="tab8">
          <br />
          <lib-favorecido-terceiro-setor [usarAtalho]="tabSelecionado(7)" [lista]="listaTerceiroSetor" [login]="login">
          </lib-favorecido-terceiro-setor>
        </div>
        <div role="tabpanel" class="tab-pane fade" id="tab9">
          <br />
          <lib-favorecido-prestador [usarAtalho]="tabSelecionado(8)" [lista]="listaTomadores" [prestador]="entidade"
            [login]="login">
          </lib-favorecido-prestador>
        </div>
        <div role="tabpanel" class="tab-pane fade" id="tab10">
          <br />
          <div class="row">
            <div class="col-12">
              <div class="table-responsive">
                <table class="table table-eddy">
                  <thead>
                    <tr>
                      <th scope="col" style="width: 20%;">Data registro</th>
                      <th scope="col" style="width: 40%;">Usuário alteração</th>
                      <th scope="col" style="width: 40%;">Razão Social</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let h of historicoRazao">
                      <td>{{h.data | date:'dd/MM/yyyy HH:mm':'pt_BR'}}</td>
                      <td>{{h.usuario}}</td>
                      <td>{{h.nome}}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br>
    <br>
    <br>
    <br>
    <div id="footer" class="row mt-4">
      <div class="offset-1 col-11 ml-5 pl-3 pt-3 mb-3">
        <button (click)="submitForm(true)" class="btn btn-sm btn-secondary">
          <img src="assets/img/global/tick.png" alt="cvs" title="Salvar" height="20" width="20">
          Salvar e novo
        </button>
      </div>
    </div>
  </form>
</div>